module.exports = __webpack_public_path__ + "img/qr-grass-roots.88b2d50d.png";